<template>
  <div class="banner" v-if="message" v-html="message"></div>
</template>

<script>
export default {
  name: 'Banner',
  props: ['message'],
  methods: {
    getMessage() {
      this.$database
        .collection('news')
        .doc('alert')
        .get()
        .then(result => {
          if (result.data().message !== '') {
            this.message = result.data().message
          }
        })
    }
  },
  mounted() {
    this.getMessage()
  }
}
</script>

<style lang="less" scoped>
div.banner {
  background-color: #c72b85;
  border-bottom: 1px solid #811755;
  border-top: 7px solid #aae8e2;
  color: white !important;
  font-weight: bold;
  line-height: 1.5em;
  padding: 1em;
  text-align: center;
}
</style>
